import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { RouteBreadcrumbsComponent } from "@directives/_layout/_page-design/route-breadcrumbs/route-breadcrumbs.component";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { VeriDirectivesModule } from "../_veri/_veri.directives.module";
import { AccordianEntryComponent } from "./accordian/accordian-entry/accordian-entry.component";
import { AccordianComponent } from "./accordian/accordian.component";
import { EmptyStateComponent } from "./empty-state/empty-state.component";
import { MaxParentWidthDirective } from "./max-parent-width/max-parent-width.directive";
import { MaxWindowBreakpointDirective } from "./max-window-breakpoint/max-window-breakpoint.directive";
import { MinParentWidthDirective } from "./min-parent-width/min-parent-width.directive";
import { MinWindowBreakpointDirective } from "./min-window-breakpoint/min-window-breakpoint.directive";
import { ResourceGroupDisplayComponent } from "./resourceGroupDisplay/resourceGroupDisplay.component";
import { RevealingColumnsComponent } from "./revealingColumns/revealingColumns.component";
import { VDialogComponent } from "./v-dialog/v-dialog.component";
import { VTabComponent } from "./v-tabs/v-tab.component";
import { VTabsComponent } from "./v-tabs/v-tabs.component";
import { VeriPanelComponent } from "./veri-panel/veri-panel.component";
import { DetailPageComponent } from "./_page-design/detail-page/detail-page.component";
import { PageActionsComponent } from "./_page-design/page-actions/page-actions.component";
import { PageTitlePillComponent } from "./_page-design/page-title-pill/page-title-pill.component";
import { PageTitleComponent } from "./_page-design/page-title/page-title.component";
import { SideBarComponent } from "./_page-design/sidebar/sidebar.component";
import { DefaultLayoutComponent } from "./_page-design/_layouts/default-layout/default-layout.component";
import { HorizontalLayoutComponent } from "./_page-design/_layouts/horizontal-layout/horizontal-layout.component";
import { VerticalLayoutComponent } from "./_page-design/_layouts/vertical-layout/vertical-layout.component";
import { VerticalMapLayoutComponent } from "./_page-design/_layouts/vertical-map-layout/vertical-map-layout.component";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    ResourceGroupDisplayComponent,
    RevealingColumnsComponent,
    EmptyStateComponent,

    VeriPanelComponent,

    DefaultLayoutComponent,
    VerticalMapLayoutComponent,
    HorizontalLayoutComponent,
    VerticalLayoutComponent,

    SideBarComponent,

    PageActionsComponent,
    PageTitleComponent,
    PageTitlePillComponent,
    DetailPageComponent,
    RouteBreadcrumbsComponent,

    VTabComponent,
    VTabsComponent,

    AccordianComponent,
    AccordianEntryComponent,
    VDialogComponent
];


const declarations: any[] = [
    MinParentWidthDirective,
    MinWindowBreakpointDirective,
    MaxParentWidthDirective,
    MaxWindowBreakpointDirective
];

@NgModule({
    imports: [
        BrowserAnimationsModule,
        OverlayModule,
        CommonModule,
        VeriDirectivesModule,
        MiscDirectivesModule,
        CoreDirectivesModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class LayoutDirectivesModule {
    constructor() {
    }
}
